/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TwoFactorSetupResult } from '../../models/two-factor-setup-result';

export interface Setup$Params {
}

export function setup(http: HttpClient, rootUrl: string, params?: Setup$Params, context?: HttpContext): Observable<StrictHttpResponse<TwoFactorSetupResult>> {
  const rb = new RequestBuilder(rootUrl, setup.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TwoFactorSetupResult>;
    })
  );
}

setup.PATH = '/auth/2fa/setup';
